import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, RouterOutlet } from '@angular/router';
import { NotificationToast } from './components/common/notification-toast/notification-toast';
import { AdaMenu } from './components/common/ada-menu/ada-menu';
import { OnInit } from '@angular/core';
import { UserService } from './services/user.service';
import { MessagingService } from './services/messaging.service';
import { AlertsService } from '../../src/app/services/alerts.service';
import { PrivacyBanner } from './components/common/privacy-banner/privacy-banner';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, AdaMenu, PrivacyBanner],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  constructor(
    public router: Router,
    private userService: UserService,
    private messagingService: MessagingService,
    /** Computes pending alerts shown in the alerts dropdown. */
    public alertsService: AlertsService,
  ) {}

  private snackBar = inject(MatSnackBar);

  private currentUserId!: number;

  get hideNav(): boolean {
    const showOnlyOn = ['/'];
    return !showOnlyOn.includes(this.router.url);
  }

  /** Docks the accessibility widget bottom-right instead of the default bottom-left on counselor pages. */
  get isCounselorView(): boolean {
    return this.router.url.startsWith('/counselors');
  }

  ngOnInit(): void {
    this.userService.getCurrentUser().subscribe((user) => {
      if (user && user.id) {
        this.messagingService.connect(user.id);
        // HTTP first — the bell must be right on load whether or not the
        // socket ever connects.
        this.alertsService.load();
      }
    });

    // Subscribed at the shell so a notification surfaces wherever the user is,
    // rather than only on pages that happen to render a nav.
    this.alertsService.alertArrived$.subscribe((alert) => {
      this.snackBar.openFromComponent(NotificationToast, {
        data: alert,
        duration: 6000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: 'app-toast-panel',
      });
    });
  }
  protected readonly title = signal('Handle');
}
